<div class="modal-header">
    <h2 class="modal-title">{{ "specialOffers.editFilesModal.title" | translate }}</h2>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="document-category row justify-content-center mb-3">
        <div class="col-12">
            <label class="label-input required">
                {{ "specialOffers.wizard.campaignDescription.attachments" | translate }}
            </label>
            <div class="import-file-container">
                <input
                    HJSuppress
                    type="file"
                    name="fileNgModel"
                    #file="ngModel"
                    [(ngModel)]="file"
                    class="input-file cursor-pointer"
                    [accept]="acceptExtensions"
                    (change)="uploadFileInStoreHandler($event, true)"/>
                <div class="import-file-label d-flex flex-column align-items-center gap-2">
                    <div class="upload-icon-box d-flex align-items-center justify-content-center">
                        <i class="app-icon icon icon-upload icon-lg"></i>
                    </div>
                    <div class="upload-info text-center">
                        <div HJSuppress class="upload-hint"
                            [innerHTML]="'common.uploadPresentationDocument' | translate">
                        </div>
                        <div HJSuppress class="upload-note">
                            {{ 'PDF '+ ('common.or' | translate) +' WORD' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-container
            *ngFor="let doc of campaignDocuments; let index=index">
            <div class="col-12">
                <div class="document-item d-flex align-items-center uploaded-file-container p-2">
                    <div class="document-name w-50 d-flex align-items-center">
                        <span
                            HJSuppress
                            class="fw-bold">
                            {{doc.documentName}}
                        </span>
                    </div>
                    <button
                        class="btn delete-btn custom-delete-btn ms-auto"
                        (click)="removeFileHandler(index)">
                        <i class="app-icon icon icon-delete icon-xl"></i>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="file.dirty" class="row d-flex justify-content-center text-danger">
        <div class="p-3">
            {{ "specialOffers.editFilesModal.confirmationMessage" | translate }}  
        </div>
    </div>
</div>

<div class="modal-footer">
  <button class="btn link-btn" (click)="closeHandler()">
    {{ "specialOffers.editFilesModal.cancel" | translate }}
  </button>
  <button class="btn primary-btn" (click)="changeHandler()">
    {{ "specialOffers.editFilesModal.apply" | translate }}
  </button>
</div>
